class LL_Dialog extends HTMLElement {
constructor() {
  super();

  this.dialogElement = this.querySelector('.js_dialog');
  this.toggleButtons = this.querySelectorAll('.js_dialogToggle');

  if (!this.dialogElement || this.toggleButtons.length === 0) {
    return;
  }

  this.dialogElement.addEventListener('click', event => {
    if (event.target === this.dialogElement) {
      this.toggleDialog();
    }
  });

  this.toggleButtons.forEach(button => {
    button.addEventListener('click', this.toggleDialog.bind(this));
  });
}

  /**
   * Toggle dialog visibility based on its current state
   */
  toggleDialog() {
    if (this.isDialogOpen()) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }

  /**
   * Check if the dialog is currently open
   * @returns {Boolean} True if the dialog is open
   */
  isDialogOpen() {
    return this.dialogElement.hasAttribute('open');
  }


  /**
   * Open the dialog and add necessary event listeners
   */
openDialog() {
  if (typeof this.dialogElement.showModal === "function") {
    this.dialogElement.showModal();
    document.body.classList.add('lc-modal-open');

    if (this.videoElement) {
      this.videoElement.play();
    }
  } else {
    console.error('The <dialog> API is not supported by this browser');
  }
}

    /**
   * Close the dialog and remove event listeners
   */
closeDialog() {
  if (this.videoElement) {
    this.videoElement.pause();
    this.videoElement.currentTime = 0;
  }

  this.dialogElement.close();
  document.body.classList.remove('lc-modal-open');
}
}

customElements.define('ll-dialog', LL_Dialog);

{
  const checkbox = document.getElementById('js_gift');
  const app = document.querySelector('#main .shopify-section--apps');
  if (checkbox) {
    checkbox.addEventListener('change', function() {
      if (checkbox.checked) {
        app.classList.add('hidden');
        const closeBtn = document.querySelector('.delivery-select-container--close');
        if (closeBtn) {
          const event = new Event('click');
          closeBtn.dispatchEvent(event);
        }

        const select = document.querySelector('select.delivery-select-container__select');
        if (select) {
          setTimeout(() => {
            select.value = '指定なし';
          }, 1000);
        }
      } else {
        app.classList.remove('hidden');
      }
    }, false);
  }
}

{
  const alertBtn = document.getElementById('js_alert');
  if (alertBtn) {
    alertBtn.addEventListener('click', function() {
      alert('この商品はギフトラッピングと一緒に購入できません。');
    })
  }
}

{
  document.addEventListener('DOMContentLoaded', initializePress);
  function initializePress(){
    if (document.getElementById('js-pressSlider')) {
      new Swiper("#js-pressSlider",{slidesPerView:3.2,slidesPerGroup:3,spaceBetween:16,breakpoints:{768:{slidesPerView:5.8,slidesPerGroup:6,spaceBetween:32}},navigation:{prevEl:"#js-pressSlider .swiper-button-prev",nextEl:"#js-pressSlider .swiper-button-next"}})
    }
  }
}

{
  document.addEventListener('DOMContentLoaded', initializePress);
  function initializePress(){
    if (document.getElementById('js-pressSlider')) {
      new Swiper("#js-pressSlider",{slidesPerView:3.2,slidesPerGroup:3,spaceBetween:16,breakpoints:{768:{slidesPerView:5.8,slidesPerGroup:6,spaceBetween:32}},navigation:{prevEl:"#js-pressSlider .swiper-button-prev",nextEl:"#js-pressSlider .swiper-button-next"}})
    }
  }
}
{
const updateSecondaryState = (media) => {
  const card = media.closest('.lc-product-card');
  if (!card) return;

  const images = media.querySelectorAll('img, svg');
  const secondMedia = images[1];
  if (!secondMedia) return;

  const isAtSecond = media.scrollLeft >= secondMedia.offsetLeft - media.clientWidth / 2;

  card.classList.toggle('is-secondary-visible', isAtSecond);
};

const syncProductCardMediaWidth = () => {
  document.querySelectorAll('.lc-product-card .product-card__media').forEach((media) => {
    const width = media.getBoundingClientRect().width;

    media.style.setProperty('--media-width', `${width}px`);
    updateSecondaryState(media);
  });
};

window.addEventListener('load', syncProductCardMediaWidth);
window.addEventListener('resize', syncProductCardMediaWidth);

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.lc-product-card__secondary-toggle');
  if (!toggle) return;

  event.preventDefault();
  event.stopPropagation();

  const card = toggle.closest('.lc-product-card');
  const media = card?.querySelector('.product-card__media');
  if (!media) return;

  const images = media.querySelectorAll('img, svg');
  const firstMedia = images[0];
  const secondMedia = images[1];

  if (!firstMedia || !secondMedia) return;

  const isAtSecond = card.classList.contains('is-secondary-visible');

  media.scrollTo({
    left: isAtSecond ? firstMedia.offsetLeft : secondMedia.offsetLeft,
    behavior: 'smooth',
  });

  card.classList.toggle('is-secondary-visible', !isAtSecond);
});

document.addEventListener(
  'scroll',
  (event) => {
    const media = event.target.closest?.('.lc-product-card .product-card__media');
    if (!media) return;

    updateSecondaryState(media);
  },
  true
);
}
// {
//   const giftModal = document.getElementById('js_giftModal');
//   const toggles = document.querySelectorAll('js_giftToggle');
//   toggles.forEach(toggle => {
//     toggle.addEventListener('click', function() {
//       giftModal.setAttribute('aria-hidden', !giftModal.getAttribute('aria-hidden'))
//     }, false);
//   });
// }